import { stats } from "@/mocks/home";

export default function StatsBanner() {
  return (
    <section className="w-full py-10 md:py-12 bg-primary-500">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="flex flex-col items-center text-center gap-2"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-white/15">
                <i className={`${stat.icon} text-white text-xl md:text-2xl`}></i>
              </div>
              <span className="text-2xl md:text-3xl font-heading text-white">
                {stat.value}
              </span>
              <span className="text-sm text-white/80">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}